import React, { ForwardedRef, forwardRef, ReactNode } from "react";
import {
  BottomSheet,
  BottomSheetProps,
  BottomSheetRef,
} from "react-spring-bottom-sheet";

import styles from "./Sheet.module.scss";
import "react-spring-bottom-sheet/dist/style.css";

interface Props {
  dataQA: string;
  children: ReactNode;
}

const Sheet = forwardRef(function Sheet(
  { children, dataQA, ...props }: Props & BottomSheetProps,
  ref: ForwardedRef<BottomSheetRef>
) {
  return (
    <BottomSheet blocking={false} data-qa={dataQA} {...props} ref={ref}>
      <div className={styles.container}>{children}</div>
    </BottomSheet>
  );
});

export default Sheet;
